var exports = {
  "q": "DiscoveryGuildHeader.module__headerTitle___SmZOZ2",
};

module.exports = exports;
